import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess";
import { useGetRequestRating } from "@/features/projects/project/view/hooks/useGetRequestRating";

export function useCanEditRequestRating(
  requestId: number | undefined,
  isArchived: boolean,
): boolean {
  const { canAccess } = useRoleAccess();
  const isEligible =
    canAccess("request.rating.edit") && !isArchived && requestId != null;
  const { data } = useGetRequestRating(isEligible ? requestId : null);

  return isEligible && Boolean(data?.rating);
}
